var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.5,
    height: 150,
    viewBox: "0 0 150.5 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stripe",
    transform: "translate(-610 -2471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_436",
    "data-name": "Rectangle 436",
    width: 150,
    height: 150,
    transform: "translate(610 2471)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2003",
    "data-name": "Path 2003",
    d: "M15.675,28.651c-3.232-1.2-5-2.125-5-3.587,0-1.24,1.019-1.948,2.834-1.948a21.783,21.783,0,0,1,9.077,2.435l1.328-8.191a25.525,25.525,0,0,0-10.937-2.347A14.015,14.015,0,0,0,3.941,17.8a9.923,9.923,0,0,0-3.5,7.97c0,6.022,3.675,8.59,9.653,10.76,3.852,1.373,5.136,2.347,5.136,3.852,0,1.461-1.24,2.3-3.5,2.3A24.39,24.39,0,0,1,1.328,39.544L0,47.824a26.99,26.99,0,0,0,12.31,2.967c3.941,0,7.217-.93,9.431-2.7,2.479-1.948,3.764-4.826,3.764-8.546,0-6.155-3.764-8.723-9.83-10.893Zm31.455-4.827,1.328-8.147H41.445V5.787L32.016,7.339l-1.362,8.339-3.316.538L26.1,23.825h4.544V39.81c0,4.162,1.063,7.04,3.232,8.811,1.816,1.461,4.428,2.17,8.1,2.17a20.389,20.389,0,0,0,5.756-.8V41.359a15.109,15.109,0,0,1-3.188.487c-2.17,0-3.1-1.107-3.1-3.631V23.825h5.684ZM68.189,15.2a6.549,6.549,0,0,0-6.553,4.55l-.664-4.074H51.364V50.126H62.344V27.766c1.373-1.683,3.321-2.291,5.978-2.291a10.52,10.52,0,0,1,1.948.133V15.467A8.945,8.945,0,0,0,68.189,15.2Zm10.273-2.934a5.8,5.8,0,1,0-5.8-5.8,5.782,5.782,0,0,0,5.8,5.8Zm-5.535,3.41H83.953V50.126H72.927Zm42.27,3.1a9.645,9.645,0,0,0-8.1-3.764c-3.188,0-5.978,1.328-8.59,4.118l-.576-3.454H88.275v47.2l10.981-1.815V49.994a16.776,16.776,0,0,0,4.959.8,13.1,13.1,0,0,0,9.83-4.073c2.967-3.233,4.472-8.236,4.472-14.834,0-5.845-1.107-10.273-3.321-13.107Zm-9.122,21.254a4.311,4.311,0,0,1-3.852,2.568,6.5,6.5,0,0,1-2.967-.664V25.552a5.975,5.975,0,0,1,4.162-2.17c2.79,0,4.162,3.011,4.162,8.9,0,3.365-.487,5.978-1.505,7.749ZM150,32.592c0-5.49-1.2-9.83-3.542-12.885-2.391-3.1-5.978-4.693-10.538-4.693-9.343,0-15.143,6.907-15.143,17.977,0,6.2,1.55,10.848,4.6,13.815,2.745,2.657,6.686,3.985,11.778,3.985,4.693,0,9.033-1.107,11.778-2.922l-1.2-7.527a19.489,19.489,0,0,1-9.387,2.258,6.707,6.707,0,0,1-4.649-1.373c-1.151-.974-1.816-2.568-2.037-4.826h18.2c.044-.531.133-3.011.133-3.808ZM131.58,29.67c.31-4.915,1.638-7.217,4.162-7.217,2.48,0,3.764,2.347,3.941,7.217Z",
    transform: "translate(610.5 2514.334)",
    fill: "#635bff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.bed396b5af849d892915f6e6e6b530bc.svg";
export { ForwardRef as ReactComponent };